import { observer } from "mobx-react-lite";

import { usePageStore } from "../../application-detail-page.lib";
import type { PaymentProofPopupAction } from "../application-control-popup.lib";
import { PaymentProofModal } from "./payment-proof-modal";

const PaymentProofPopupController = observer(({ popupAction }: { popupAction: PaymentProofPopupAction }) => {
  const store = usePageStore();

  const handleClose = () => {
    store?.setPopupAction(null);
  };

  return <PaymentProofModal requestId={popupAction.requestId} isReplacement={popupAction.isReplacement} onClose={handleClose} />;
});

export const PaymentProofPopup = observer(() => {
  const store = usePageStore();
  const popupAction = store?.popupAction;

  if (!popupAction || popupAction.type !== "payment-proof") {
    return null;
  }

  return <PaymentProofPopupController popupAction={popupAction} />;
});
